"use client";
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React from "react";
import { InteractionsProvider } from "./interactions";
import { createIX2Engine } from "./devlink";
export const DevLinkContext = /*#__PURE__*/ React.createContext({});
export const DevLinkProvider = (_param)=>{
    var { children } = _param, context = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ React.createElement(DevLinkContext.Provider, {
        value: context
    }, /*#__PURE__*/ React.createElement(InteractionsProvider, {
        createEngine: createIX2Engine
    }, children));
};
